import Icon from '../../components/Icon.vue'

Icon.register({"brands/google-drive":{"width":512,"height":512,"paths":[{"d":"M339 314.9L175.4 32H336.6L500.2 314.9H339zM201.5 338.5L120.9 480H431.4L512 338.5H201.5zM154.1 67.4L0 338.5 80.6 480 237 208.8 154.1 67.4z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/google-drive.js
// module id = null
// module chunks = 